import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchPortfolio } from '../services/api';

// Create context
const PortfolioContext = createContext(null);

// Provider component
export const PortfolioProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const portfolioData = await fetchPortfolio();
        setData(portfolioData);
        setError(null);
      } catch (err) {
        console.error('Failed to load portfolio data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const value = {
    data,
    loading,
    error,
    hero: data?.hero,
    about: data?.about,
    ventures: data?.ventures || [],
    achievements: data?.achievements || [],
    leadership: data?.leadership || [],
    clients: data?.clients || [],
    media: data?.media || [],
    talks: data?.talks || [],
    education: data?.education || [],
    contact: data?.contact,
  };

  return (
    <PortfolioContext.Provider value={value}>
      {children}
    </PortfolioContext.Provider>
  );
};

// Custom hook to use portfolio data
export const usePortfolio = () => {
  const context = useContext(PortfolioContext);
  if (!context) {
    throw new Error('usePortfolio must be used within a PortfolioProvider');
  }
  return context;
};

export default PortfolioContext;
